import * as Sentry from '@sentry/browser';
import {BrowserTracing} from '@sentry/tracing';

import {appConfig} from '$lib/configs';

const {sentry} = appConfig;

if (sentry.dsn) {
  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}
